var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.04 20.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.02,0C4.93,0,0,4.2,0,9.38c0,2.19,.86,4.22,2.23,5.66L0,20.2l6.94-2.08c8.72,2.39,15.09-2.99,15.09-8.75C22.04,4.2,17.1,0,11.02,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.1e754e1755fea0da72b2b382a993a52e.svg";
export { ForwardRef as ReactComponent };